<template>
 <div>
     <section class="simple-nav">
            <div class="simplenav_wrap">
            <div class="simplenav_flex">
                <div class="nav-left-div">
                <a href="#" class="link-block w-inline-block"><img src="@/assets/images/OhMyMeds_Logo_w.svg" loading="lazy" alt="" class="image-545"></a>
                <div class="nav-menu-links-div desk">
                    
                    <div class="div-block-1129"></div>
                </div>
                </div>
            </div>
            </div>
            <div class="nav-shadow"></div>
            <div class="mobile-nav-div">
            <div data-animation="default" data-collapse="medium" data-duration="400" data-easing="ease" data-easing2="ease" role="banner" class="navbar-mobile w-nav">
                <a href="#" class="brand home w-nav-brand"><img src="@/assets/images/OhMyMeds_Logo_w.svg" loading="lazy" alt="" class="image-551"></a>
                
            <div class="w-nav-overlay" data-wf-ignore="" id="w-nav-overlay-0"></div></div>
            <div class="div-block-1958"></div>
            </div>
        </section>
     <section class="form2-section">
         <div class="form2-main-wrap"></div>
     </section>
     <div class="form-section _2">
         <div class="enroll-div-wrap _2">
         </div>
         <div class="questions-div">
             <div class="question-container _2">
                 <div class="question-div-2">
                     <div class="text-block-513 end bold">We&#x27;re Sorry</div>
                     <div class="form-subs end break">{{ displayMessage }}</div>
                     <a href="#" class="button-65 finish w-button">Continue <span class="text-span-172">-&gt;</span></a>
                     <div class="div-block-1492">
                         <a href="/" class="link-39">Learn More</a>
                     </div>
                 </div>
             </div>
         </div>
     </div>
 </div>
</template>

<script>
export default {
    name: 'LeadDisqualified',

    data() {
        return {
            defaultMessages: {
                'validation_error': 'There was an error validating your request.',
                'invalid_order_status': 'Your order status is not valid for this action.',
                'default': 'Based on the information you provided, you currently do not qualify for our programs.'
            }
        }
    },

    computed: {
        displayMessage() {
            // Get the reason and message from query params
            const {
                reason,
                message
            } = this.$route.query;

            if (message) {
                // If there's a specific message, use it
                return decodeURIComponent(message);
            } else if (reason && this.defaultMessages[reason]) {
                // If there's a reason with a default message, use that
                return this.defaultMessages[reason];
            } else {
                // Fall back to the default message
                return this.defaultMessages.default;
            }
        }
    },

    created() {
        // Store redirect path if it exists
        if (this.$route.query.redirect) {
            localStorage.setItem('previousPath', decodeURIComponent(this.$route.query.redirect));
        }
    },

    methods: {
        goBack() {
            const previousPath = localStorage.getItem('previousPath');
            if (previousPath) {
                this.$router.push(previousPath);
                localStorage.removeItem('previousPath');
            } else {
                this.$router.push('/');
            }
        }
    }
}
</script>

<style scoped>
.back-link {
    cursor: pointer;
    text-decoration: none;
}

.questions-div {
    padding-top: 30px;
    padding-bottom: 50px;
    max-width: 100%;
    padding-left: 20px;
    padding-right: 20px;
}
</style>
